"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M16.652 5.685l-.056-1.598c-.014-.414.31-.76.724-.776.414-.013.76.31.775.725l.116 3.32c.016.413-.308.76-.722.775l-3.334.117c-.414.014-.762-.31-.776-.724-.015-.414.31-.76.723-.775l1.38-.05c-1.08-.695-2.347-1.078-3.678-1.078-3.738 0-6.766 3.015-6.766 6.734 0 3.718 3.028 6.734 6.766 6.734s6.767-3.016 6.767-6.734c0-.414.335-.75.75-.75.413 0 .75.336.75.75 0 4.548-3.703 8.234-8.268 8.234-4.565 0-8.266-3.686-8.266-8.234 0-4.55 3.7-8.234 8.266-8.234 1.773 0 3.46.56 4.85 1.565z';